/**
 * Cellule de stat "Précision" — conçue pour vivre DANS un conteneur .stat-strip
 * (bloc bordé unique, cellules séparées par des hairlines divide-x), qui a
 * remplacé les cartes KPI flottantes.
 */
export function KpiCard({
  label,
  value,
  hint,
}: {
  label: string;
  value: string | number;
  hint?: string;
}) {
  return (
    <div className="stat-cell">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value}</div>
      {hint && <div className="text-xs t-muted">{hint}</div>}
    </div>
  );
}
